// Generated by scripts/generate-branded-icons.ts — do not edit by hand.
export const paths: string[] = [
  'M6.1 9.35C6 8.8 5.7 8.38 5.1 7.8C4.1 6.82 3.75 6.02 3.75 5.1C3.75 3.18 5.31 1.7 7.2 1.7H8.8C10.69 1.7 12.25 3.18 12.25 5.1C12.25 6.02 11.9 6.82 10.9 7.8C10.3 8.38 10 8.8 9.9 9.35',
  'M6 11.65H10M6.9 13.85H9.1',
];
